import Component from 'vue-class-component'
import Router from 'vue-router'
import Vue from 'vue'
import config from './config'
// Register the router hooks with their names
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave',
])
Vue.use(Router)
export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: config.app_name,
  routes: [
    {
      path: '/demoTest',
      component: () => import('./pages/demoTest/index.vue'),
    },
    {
      path: '/talentTest',
      component: () => import('./pages/talentTest/index.vue'),
      name: '宝宝天赋测试',
    },
    {
      path: '*',
      component: () => import('./pages/talentTest/index.vue'),
    },
    {
      path: '/abLink',
      component: () => import('./pages/abLink/index.vue'),
      name: '常青藤爸爸',
    },
    {
      path: '/talentShow',
      component: () => import('./pages/talentShow/index.vue'),
      name: '常青藤爸爸',
    },
    {
      path: '/parentTypeTest',
      component: () => import('./pages/parentTypeTest/index.vue'),
      name: '常青藤爸爸',
    },
    {
      path: '/invitationMarket',
      component: () => import('./pages/invitationMarket/index.vue'),
      name: '常青藤爸爸',
      children: [
        {
          path: 'putGoodsPop', // 带选择课程sku的活动详情页
          component: () => import('./pages/invitationMarket/putGoodsPop.vue'),
          name: 'putGoodsPop',
        },
        {
          path: 'actDetail', // 带选择课程sku的活动详情页
          component: () => import('./pages/invitationMarket/actDetail.vue'),
          name: 'actDetail',
        },
        {
          path: 'appPayResult', // 带选择课程sku的活动详情页
          component: () => import('./pages/invitationMarket/appPayResult.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'orderConfirm',
          component: () => import('./pages/invitationMarket/order.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'verifyPayResult',
          component: () =>
            import('./pages/invitationMarket/verifyPayResult.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'address',
          component: () =>
            import('./pages/invitationMarket/address/addressList.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'modifyAddress',
          component: () =>
            import('./pages/invitationMarket/address/modifyAddress.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'qrCode2', // 微信H5添加老师页
          component: () => import('./pages/invitationMarket/qrCode2.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'loadingView', // 支付loading页
          component: () => import('./pages/invitationMarket/loadingView.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'activation', // 课程激活(微信生态外的H5投放指引用户添加老师)
          component: () =>
            import('./pages/invitationMarket/courseActivation.vue'),
          name: '常青藤爸爸',
        },
      ],
    },
    {
      path: '/teamFree',
      component: () => import('./pages/teamFree/index.vue'),
      name: '常青藤爸爸',
      children: [
        {
          path: 'teamDetail',
          component: () => import('./pages/teamFree/views/detail.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'teamRecord',
          component: () => import('./pages/teamFree/views/record.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'myPrize',
          component: () => import('./pages/teamFree/views/myPrize.vue'),
          name: '常青藤爸爸',
        },
      ],
    },
    {
      path: '/freeExperience',
      component: () => import('./pages/freeExperience/index.vue'),
      name: '常青藤爸爸',
    },
    {
      path: '/reimsAssess',
      component: () => import('./pages/reimsAssess/index.vue'),
      name: '常青藤爸爸',
      children: [
        {
          path: 'index',
          component: () => import('./pages/reimsAssess/views/index.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'babyMessage',
          component: () => import('./pages/reimsAssess/views/babyMessage.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'testPage',
          component: () => import('./pages/reimsAssess/views/testPage.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'needKnow',
          component: () => import('./pages/reimsAssess/views/needKnow.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'lexile',
          component: () => import('./pages/reimsAssess/views/lexile.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'report',
          component: () => import('./pages/reimsAssess/views/report.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'result',
          component: () => import('./pages/reimsAssess/views/result.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'sharePage',
          component: () => import('./pages/reimsAssess/views/sharePage.vue'),
          name: '常青藤爸爸',
        },
      ],
    },
    {
      path: '/questionnaire',
      component: () => import('./pages/questionNaire/index.vue'),
      name: '常青藤爸爸',
      children: [
        {
          path: 'startPage',
          component: () => import('./pages/questionNaire/views/index.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'testPage',
          component: () => import('./pages/questionNaire/views/test.vue'),
          name: '常青藤爸爸',
        },
        {
          path: 'reportPage',
          component: () => import('./pages/questionNaire/views/result.vue'),
          name: '常青藤爸爸',
        },
      ],
    },
    {
      path: '/learningReport',
      component: () => import('./pages/learningReport/index.vue'),
      name: '学习报告',
    },
    {
      path: '/fullGift',
      component: () => import('./pages/fullGift/fullGiftList.vue'),
      name: '直播满赠',
    },
    {
      path: '/fullGift/activityDetail',
      component: () => import('./pages/fullGift/activityDetail.vue'),
      name: '消费赢壕礼',
    },
    {
      path: '/fullGift/myReward',
      component: () => import('./pages/fullGift/myReward.vue'),
      name: '我的奖品',
    },
    {
      path: '/fullGift/myPurchaseRecord',
      component: () => import('./pages/fullGift/myPurchaseRecord.vue'),
      name: '消费记录',
    },
  ],
})
